import React, { useState } from 'react';
import {
  TopToolbar,
  CreateButton,
  FilterButton,
  Button,
} from 'react-admin';
import { useNavigate } from 'react-router-dom';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import HistoryIcon from '@mui/icons-material/History';

import type { PricingType } from './types';
import PricingRulesImportDialog from './PricingRulesImportDialog';

interface PricingRulesActionsProps {
  pricingType: PricingType;
}

const PricingRulesActions = ({ pricingType }: PricingRulesActionsProps) => {
  const [isImportDialogOpen, setIsImportDialogOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <TopToolbar>
      <FilterButton />
      <CreateButton />
      <Button
        label="Import"
        onClick={() => setIsImportDialogOpen(true)}
        startIcon={<FileUploadIcon />}
      />
      <Button
        label="History"
        onClick={() => navigate('history')}
        startIcon={<HistoryIcon />}
      />
      <PricingRulesImportDialog
        open={isImportDialogOpen}
        onClose={() => setIsImportDialogOpen(false)}
        pricingType={pricingType}
      />
    </TopToolbar>
  );
};

export default PricingRulesActions;
